<template>
  <div>
    <video class="video-js"
           ref="videoPlayer"
           :playlist="playlist">
      <source :src="src" type="video/mp4" />
      <source :src="altSrc" type="video/webm" />
      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that
        <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
      </p>
    </video>
    <div class="vjs-playlist"></div>
    <a v-show="isFullScreen" @click.prevent="closeFullScreen" href="#" class="video-js__close-fs-btn"></a>
  </div>
</template>

<script>

  import videojs from 'video.js';
  import 'videojs-playlist';
  import 'videojs-playlist-ui';

  export default {
    name: "VideoPlayer",
    props: {
      options: {
        default() {
          return {
            height: 500,
            controls: true,
            aspectRatio: '16:9',
            preload: 'auto',
            responsive: true,
            language: document.querySelector('body').getAttribute('data-lang'),
            languages: {
              nl: {
                "Now Playing": "Nu aan het spelen",
                "Up Next": "Volgende",
                "Untitled Video": "Video zonder titel",
                "Play Video": "Video afspelen",
                "Audio Player": "Audiospeler",
                "Video Player": "Videospeler",
                "Play": "Afspelen",
                "Pause": "Pauzeren",
                "Replay": "Opnieuw afspelen",
                "Current Time": "Huidige tijd",
                "Duration": "Tijdsduur",
                "Remaining Time": "Resterende tijd",
                "Stream Type": "Streamtype",
                "LIVE": "LIVE",
                "Loaded": "Geladen",
                "Progress": "Voortgang",
                "Progress Bar": "Voortgangsbalk",
                "progress bar timing: currentTime={1} duration={2}": "{1} van {2}",
                "Fullscreen": "Volledig scherm",
                "Non-Fullscreen": "Geen volledig scherm",
                "Mute": "Dempen",
                "Unmute": "Niet dempen",
                "Playback Rate": "Afspeelsnelheid",
                "Subtitles": "Ondertiteling",
                "subtitles off": "ondertiteling uit",
                "Captions": "Bijschriften",
                "captions off": "bijschriften uit",
                "Chapters": "Hoofdstukken",
                "Descriptions": "Beschrijvingen",
                "descriptions off": "beschrijvingen uit",
                "Audio Track": "Audiospoor",
                "Volume Level": "Geluidsniveau",
                "You aborted the media playback": "U heeft het afspelen van de media afgebroken",
                "A network error caused the media download to fail part-way.": "Een netwerkfout heeft ervoor gezorgd dat het downloaden van de media halverwege is mislukt.",
                "The media could not be loaded, either because the server or network failed or because the format is not supported.": "De media kon niet worden geladen, dit komt doordat of de server of het netwerk mislukt of doordat het formaat niet wordt ondersteund.",
                "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Het afspelen van de media is afgebroken door een probleem met beschadeigde gegevens of doordat de media functies gebruikt die uw browser niet ondersteund.",
                "No compatible source was found for this media.": "Er is geen geschikte bron voor deze media gevonden.",
                "The media is encrypted and we do not have the keys to decrypt it.": "De media is versleuteld en we hebben de sleutels niet om deze te ontsleutelen.",
                "Play Video": "Video afspelen",
                "Close": "Sluiten",
                "Close Modal Dialog": "Extra venster sluiten",
                "Modal Window": "Extra venster",
                "This is a modal window": "Dit is een extra venster",
                "This modal can be closed by pressing the Escape key or activating the close button.": "Dit venster kan worden gesloten door op de Escape-toets te drukken of door de sluiten-knop te activeren.",
                ", opens captions settings dialog": ", opent instellingen-venster voor bijschriften",
                ", opens subtitles settings dialog": ", opent instellingen-venster voor ondertitelingen",
                ", opens descriptions settings dialog": ", opent instellingen-venster voor beschrijvingen",
                ", selected": ", geselecteerd",
                "captions settings": "bijschriften-instellingen",
                "subtitles settings": "ondertiteling-instellingen",
                "descriptions settings": "beschrijvingen-instellingen",
                "Text": "Tekst",
                "White": "Wit",
                "Black": "Zwart",
                "Red": "Rood",
                "Green": "Groen",
                "Blue": "Blauw",
                "Yellow": "Geel",
                "Magenta": "Magenta",
                "Cyan": "Cyaan",
                "Background": "Achtergrond",
                "Window": "Venster",
                "Transparent": "Transparant",
                "Semi-Transparent": "Semi-transparant",
                "Opaque": "Ondoorzichtig",
                "Font Size": "Lettergrootte",
                "Text Edge Style": "Stijl tekstrand",
                "None": "Geen",
                "Raised": "Verhoogd",
                "Depressed": "Ingedrukt",
                "Uniform": "Uniform",
                "Dropshadow": "Schaduw",
                "Font Family": "Lettertype",
                "Proportional Sans-Serif": "Proportioneel sans-serif",
                "Monospace Sans-Serif": "Monospace sans-serif",
                "Proportional Serif": "Proportioneel serif",
                "Monospace Serif": "Monospace serif",
                "Casual": "Luchtig",
                "Script": "Script",
                "Small Caps": "Kleine hoofdletters",
                "Reset": "Herstellen",
                "restore all settings to the default values": "alle instellingen naar de standaardwaarden herstellen",
                "Done": "Klaar",
                "Caption Settings Dialog": "Venster voor bijschriften-instellingen",
                "Beginning of dialog window. Escape will cancel and close the window.": "Begin van dialoogvenster. Escape zal annuleren en het venster sluiten.",
                "End of dialog window.": "Einde van dialoogvenster."
              }
            }
          };
        },
        type: Object
      },
      src: {
        default: '',
        type: String,
      },
      altSrc: {
        default: '',
        type: String
      },
      playlist: {
        default: () => { },
        type: [Object, Array]
      }
    },
    data() {
      return {
        player: null,
        isFullScreen: false
      }
    },
    mounted() {
      let that = this;
      this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() { });

      this.player.playlist(this.playlist);
      this.player.playlistUi();


      document.querySelector('.video-js').appendChild(document.querySelector('.video-js__close-fs-btn'));

      document.addEventListener('fullscreenchange', () => {
        if (document.fullscreenElement) {
          that.isFullScreen = true;
        } else {
          that.isFullScreen = false;
        }
      });

      if (window.innerWidth < 1023) {
        document.querySelector('.vjs-big-play-button').addEventListener("click", () => {
          document.querySelector('.vjs-fullscreen-control').click();
        });
      }

    },
    beforeDestroy() {
      if (this.player) {
        this.player.dispose()
      }
    },
    methods: {
      closeFullScreen() {
        document.querySelector('.vjs-fullscreen-control').click();
      }
    }
  }
</script>